import type { FC, SVGProps } from 'react';

import icon3dCardboardIcon from '@/assets/icons/3d-cardboard.svg';
import icon3dModelIcon from '@/assets/icons/3d-model.svg';
import icon3dTvIcon from '@/assets/icons/3d-tv.svg';
import icon4v360Icon from '@/assets/icons/4v-360.svg';
import icon4vCrownIcon from '@/assets/icons/4v-crown.svg';
import icon4vLeftIcon from '@/assets/icons/4v-left.svg';
import icon4vPavillionIcon from '@/assets/icons/4v-pavillion.svg';
import icon4vRightIcon from '@/assets/icons/4v-right.svg';
import icon4vSideViewTableDownIcon from '@/assets/icons/4v-side-view-table-down.svg';
import icon4vSideViewTableUpIcon from '@/assets/icons/4v-side-view-table-up.svg';
import addModelIcon from '@/assets/icons/add-model.svg';
import addModelSquaredIcon from '@/assets/icons/add-model-squared.svg';
import addPersonIcon from '@/assets/icons/add-person.svg';
import apertureIcon from '@/assets/icons/aperture.svg';
import arrowBoldDownIcon from '@/assets/icons/arrow-bold-down.svg';
import arrowBoldLeftIcon from '@/assets/icons/arrow-bold-left.svg';
import arrowBoldRightIcon from '@/assets/icons/arrow-bold-right.svg';
import arrowLtDownIcon from '@/assets/icons/arrow-lt-down.svg';
import arrowLtLeftIcon from '@/assets/icons/arrow-lt-left.svg';
import arrowLtRightIcon from '@/assets/icons/arrow-lt-right.svg';
import arrowLtUpIcon from '@/assets/icons/arrow-lt-up.svg';
import arrowMidDownIcon from '@/assets/icons/arrow-mid-down.svg';
import arrowMidLeftIcon from '@/assets/icons/arrow-mid-left.svg';
import arrowMidRightIcon from '@/assets/icons/arrow-mid-right.svg';
import arrowMidUpIcon from '@/assets/icons/arrow-mid-up.svg';
import arrowSelectorDownIcon from '@/assets/icons/arrow-selector-down.svg';
import arrowSelectorUpIcon from '@/assets/icons/arrow-selector-up.svg';
import arrowsAscIcon from '@/assets/icons/arrows-asc.svg';
import arrowsDescIcon from '@/assets/icons/arrows-desc.svg';
import availableDataIcon from '@/assets/icons/available-data.svg';
import backHandIcon from '@/assets/icons/back-hand.svg';
import backHandPracticeIcon from '@/assets/icons/back-hand-practice.svg';
import blockIcon from '@/assets/icons/block.svg';
import bookIcon from '@/assets/icons/book.svg';
import bookmarkIcon from '@/assets/icons/bookmark.svg';
import bookmarkFillIcon from '@/assets/icons/bookmark-fill.svg';
import brainStereoVisionIcon from '@/assets/icons/brain-stereo-vision.svg';
import calendarIcon from '@/assets/icons/calendar.svg';
import cancelledIcon from '@/assets/icons/cancelled.svg';
import carbonProjectIcon from '@/assets/icons/carbon-project.svg';
import chatIcon from '@/assets/icons/chat.svg';
import checkIcon from '@/assets/icons/check.svg';
import clockIcon from '@/assets/icons/clock.svg';
import clockBackIcon from '@/assets/icons/clock-back.svg';
import closeIcon from '@/assets/icons/close.svg';
import cloudUploadIcon from '@/assets/icons/cloud-upload.svg';
import codeIcon from '@/assets/icons/code.svg';
import collapseAllIcon from '@/assets/icons/collapse-all.svg';
import collectionIcon from '@/assets/icons/collection.svg';
import colorNameIcon from '@/assets/icons/color-name.svg';
import colorProbabilityIcon from '@/assets/icons/color-probability.svg';
import colorStrengthIcon from '@/assets/icons/color-strength.svg';
import communitiesIcon from '@/assets/icons/communities.svg';
import compareIcon from '@/assets/icons/compare.svg';
import compareArrowsIcon from '@/assets/icons/compare-arrows.svg';
import compareFillIcon from '@/assets/icons/compare-fill.svg';
import completedIcon from '@/assets/icons/completed.svg';
import controlsIcon from '@/assets/icons/controls.svg';
import cubeIcon from '@/assets/icons/cube.svg';
import cubeRotationIcon from '@/assets/icons/cube-rotation.svg';
import cutBrandIcon from '@/assets/icons/cut-brand.svg';
import cutwiseIcon from '@/assets/icons/cutwise.svg';
import cutwiseDriveIcon from '@/assets/icons/cutwise-drive.svg';
import cyclopsVisionIcon from '@/assets/icons/cyclops-vision.svg';
import deadzoneIcon from '@/assets/icons/deadzone.svg';
import deleteIcon from '@/assets/icons/delete.svg';
import descriptionOffIcon from '@/assets/icons/description-off.svg';
import descriptionOnIcon from '@/assets/icons/description-on.svg';
import diamondIcon from '@/assets/icons/diamond.svg';
import diamondFilledIcon from '@/assets/icons/diamond-filled.svg';
import diamondShineIcon from '@/assets/icons/diamond-shine.svg';
import distanceToDiamondIcon from '@/assets/icons/distance-to-diamond.svg';
import distanceToInclusionsIcon from '@/assets/icons/distance-to-inclusions.svg';
import distanceToRoughIcon from '@/assets/icons/distance-to-rough.svg';
import documentationIcon from '@/assets/icons/documentation.svg';
import downloadIcon from '@/assets/icons/download.svg';
import dragIcon from '@/assets/icons/drag.svg';
import dragHandleIcon from '@/assets/icons/drag-handle.svg';
import editIcon from '@/assets/icons/edit.svg';
import emailIcon from '@/assets/icons/email.svg';
import expandIcon from '@/assets/icons/expand.svg';
import expandAllIcon from '@/assets/icons/expand-all.svg';
import facebookIcon from '@/assets/icons/facebook.svg';
import failedIcon from '@/assets/icons/failed.svg';
import fcrfSubgradesIcon from '@/assets/icons/fcrf-subgrades.svg';
import fileConversionIcon from '@/assets/icons/file-conversion.svg';
import fileTreeIcon from '@/assets/icons/file-tree.svg';
import filterIcon from '@/assets/icons/filter.svg';
import folderIcon from '@/assets/icons/folder.svg';
import folderAddIcon from '@/assets/icons/folder-add.svg';
import folderMoveIcon from '@/assets/icons/folder-move.svg';
import fullProtectIcon from '@/assets/icons/full-protect.svg';
import fullscreenOffIcon from '@/assets/icons/fullscreen-off.svg';
import fullscreenOnIcon from '@/assets/icons/fullscreen-on.svg';
import gemIcon from '@/assets/icons/gem.svg';
import grayscaleIcon from '@/assets/icons/grayscale.svg';
import gyroIcon from '@/assets/icons/gyro.svg';
import hamburgerIcon from '@/assets/icons/hamburger.svg';
import helpIcon from '@/assets/icons/help.svg';
import historyIcon from '@/assets/icons/history.svg';
import historyEventIcon from '@/assets/icons/history-event.svg';
import inclusionIcon from '@/assets/icons/inclusion.svg';
import inclusionsInsideIcon from '@/assets/icons/inclusions-inside.svg';
import inclusionsInsideOldIcon from '@/assets/icons/inclusions-inside-old.svg';
import infoIcon from '@/assets/icons/info.svg';
import informationIcon from '@/assets/icons/information.svg';
import inspectIcon from '@/assets/icons/inspect.svg';
import instagramIcon from '@/assets/icons/instagram.svg';
import jewelryIcon from '@/assets/icons/jewelry.svg';
import keyArrowDownIcon from '@/assets/icons/key-arrow-down.svg';
import keyArrowLeftIcon from '@/assets/icons/key-arrow-left.svg';
import keyArrowRightIcon from '@/assets/icons/key-arrow-right.svg';
import keyCtrlIcon from '@/assets/icons/key-ctrl.svg';
import keyEnterIcon from '@/assets/icons/key-enter.svg';
import keyOptionIcon from '@/assets/icons/key-option.svg';
import keyShiftIcon from '@/assets/icons/key-shift.svg';
import leftRightEyeIcon from '@/assets/icons/left-right-eye.svg';
import leiaTabletIcon from '@/assets/icons/leia-tablet.svg';
import lensF11Icon from '@/assets/icons/lens-f-11.svg';
import lensF16Icon from '@/assets/icons/lens-f-16.svg';
import lensF28Icon from '@/assets/icons/lens-f-28.svg';
import lensFInfinityIcon from '@/assets/icons/lens-f-infinity.svg';
import lightingIcon from '@/assets/icons/lighting.svg';
import lightingD65Icon from '@/assets/icons/lighting-d65.svg';
import lightingFluorescentIcon from '@/assets/icons/lighting-fluorescent.svg';
import lightingLedIcon from '@/assets/icons/lighting-led.svg';
import likeIcon from '@/assets/icons/like.svg';
import likeFillIcon from '@/assets/icons/like-fill.svg';
import linkIcon from '@/assets/icons/link.svg';
import linkInfoIcon from '@/assets/icons/link-info.svg';
import linkedinIcon from '@/assets/icons/linkedin.svg';
import longArrowRightIcon from '@/assets/icons/long-arrow-right.svg';
import markerCutwiseGradeIcon from '@/assets/icons/marker-cutwise-grade.svg';
import markerLaboratoryGradeIcon from '@/assets/icons/marker-laboratory-grade.svg';
import markerManualGradeIcon from '@/assets/icons/marker-manual-grade.svg';
import markerSupplierGradeIcon from '@/assets/icons/marker-supplier-grade.svg';
import marquiseIcon from '@/assets/icons/marquise.svg';
import mediaIcon from '@/assets/icons/media.svg';
import metricsBrightnessIcon from '@/assets/icons/metrics-brightness.svg';
import metricsBrightnessFaceupIcon from '@/assets/icons/metrics-brightness-faceup.svg';
import metricsBrillianceIcon from '@/assets/icons/metrics-brilliance.svg';
import metricsCaratIcon from '@/assets/icons/metrics-carat.svg';
import metricsClarityIcon from '@/assets/icons/metrics-clarity.svg';
import metricsColorIcon from '@/assets/icons/metrics-color.svg';
import metricsColorMaterialIcon from '@/assets/icons/metrics-color-material.svg';
import metricsColorPavilionIcon from '@/assets/icons/metrics-color-pavilion.svg';
import metricsColorTableIcon from '@/assets/icons/metrics-color-table.svg';
import metricsCuletIcon from '@/assets/icons/metrics-culet.svg';
import metricsCutIcon from '@/assets/icons/metrics-cut.svg';
import metricsCutPerfIcon from '@/assets/icons/metrics-cut-perf.svg';
import metricsCutwiseColorIcon from '@/assets/icons/metrics-cutwise-color.svg';
import metricsDurabilityIcon from '@/assets/icons/metrics-durability.svg';
import metricsFireIcon from '@/assets/icons/metrics-fire.svg';
import metricsFluorIcon from '@/assets/icons/metrics-fluor.svg';
import metricsFluorTableIcon from '@/assets/icons/metrics-fluor-table.svg';
import metricsGirdleIcon from '@/assets/icons/metrics-girdle.svg';
import metricsIdentIcon from '@/assets/icons/metrics-ident.svg';
import metricsIdentificationIcon from '@/assets/icons/metrics-identification.svg';
import metricsLaboratoryColorIcon from '@/assets/icons/metrics-laboratory-color.svg';
import metricsManualColorIcon from '@/assets/icons/metrics-manual-color.svg';
import metricsMeasurmentsIcon from '@/assets/icons/metrics-measurments.svg';
import metricsMilkinessIcon from '@/assets/icons/metrics-milkiness.svg';
import metricsNormalizedCutPerfIcon from '@/assets/icons/metrics-normalized–cut-perf.svg';
import metricsOpticalPerformanceIcon from '@/assets/icons/metrics-optical-performance.svg';
import metricsOpticalPerformanceAreaIcon from '@/assets/icons/metrics-optical-performance-area.svg';
import metricsOpticalSymmetryIcon from '@/assets/icons/metrics-optical-symmetry.svg';
import metricsPolishIcon from '@/assets/icons/metrics-polish.svg';
import metricsScintillationIcon from '@/assets/icons/metrics-scintillation.svg';
import metricsShapeIcon from '@/assets/icons/metrics-shape.svg';
import metricsSpreadIcon from '@/assets/icons/metrics-spread.svg';
import metricsSupplierColorIcon from '@/assets/icons/metrics-supplier-color.svg';
import metricsSymmetryIcon from '@/assets/icons/metrics-symmetry.svg';
import metricsTransparencyIcon from '@/assets/icons/metrics-transparency.svg';
import metricsTreatmentIcon from '@/assets/icons/metrics-treatment.svg';
import modelsLinkedIcon from '@/assets/icons/models-linked.svg';
import moreIcon from '@/assets/icons/more.svg';
import moreCirclesIcon from '@/assets/icons/more-circles.svg';
import multistageIcon from '@/assets/icons/multistage.svg';
import multistageSharedIcon from '@/assets/icons/multistage-shared.svg';
import munsellIcon from '@/assets/icons/munsell.svg';
import myListsIcon from '@/assets/icons/my-lists.svg';
import nextIcon from '@/assets/icons/next.svg';
import octonusColorIcon from '@/assets/icons/octonus-color.svg';
import ovalIcon from '@/assets/icons/oval.svg';
import paletteIcon from '@/assets/icons/palette.svg';
import pauseIcon from '@/assets/icons/pause.svg';
import pencilIcon from '@/assets/icons/pencil.svg';
import pendingIcon from '@/assets/icons/pending.svg';
import pinFilledIcon from '@/assets/icons/pin-filled.svg';
import pinOffIcon from '@/assets/icons/pin-off.svg';
import pinOnIcon from '@/assets/icons/pin-on.svg';
import pinUnfilledIcon from '@/assets/icons/pin-unfilled.svg';
import pinterestIcon from '@/assets/icons/pinterest.svg';
import playIcon from '@/assets/icons/play.svg';
import plusIcon from '@/assets/icons/plus.svg';
import preciseFastIcon from '@/assets/icons/precise-fast.svg';
import prevIcon from '@/assets/icons/prev.svg';
import princessIcon from '@/assets/icons/princess.svg';
import printerIcon from '@/assets/icons/printer.svg';
import privateAccessForUsersIcon from '@/assets/icons/private-access-for-users.svg';
import productsNewIcon from '@/assets/icons/products-new.svg';
import productsRemovedIcon from '@/assets/icons/products-removed.svg';
import projectIcon from '@/assets/icons/project.svg';
import projectSharedIcon from '@/assets/icons/project-shared.svg';
import protectIcon from '@/assets/icons/protect.svg';
import qrIcon from '@/assets/icons/qr.svg';
import radarIcon from '@/assets/icons/radar.svg';
import recentSharedWithMeIcon from '@/assets/icons/recent-shared-with-me.svg';
import reprojectionIcon from '@/assets/icons/reprojection.svg';
import resetCameraIcon from '@/assets/icons/reset-camera.svg';
import roughIcon from '@/assets/icons/rough.svg';
import rough2Icon from '@/assets/icons/rough-2.svg';
import roughCavernsIcon from '@/assets/icons/rough-caverns.svg';
import roughInclusionsIcon from '@/assets/icons/rough-inclusions.svg';
import roughSharedIcon from '@/assets/icons/rough-shared.svg';
import roughSurfaceIcon from '@/assets/icons/rough-surface.svg';
import roundIcon from '@/assets/icons/round.svg';
import searchIcon from '@/assets/icons/search.svg';
import secondDisplayIcon from '@/assets/icons/second-display.svg';
import selectorDownIcon from '@/assets/icons/selector-down.svg';
import selectorUpIcon from '@/assets/icons/selector-up.svg';
import settingsOffIcon from '@/assets/icons/settings-off.svg';
import settingsOnIcon from '@/assets/icons/settings-on.svg';
import shareIcon from '@/assets/icons/share.svg';
import shareOutlineIcon from '@/assets/icons/share-outline.svg';
import showAllIcon from '@/assets/icons/show-all.svg';
import sidebarIcon from '@/assets/icons/sidebar.svg';
import singlescaleOffIcon from '@/assets/icons/singlescale-off.svg';
import singlescaleOnIcon from '@/assets/icons/singlescale-on.svg';
import sortDownIcon from '@/assets/icons/sort-down.svg';
import sortUpIcon from '@/assets/icons/sort-up.svg';
import spectrumCuboidIcon from '@/assets/icons/spectrum-cuboid.svg';
import spectrumCushionIcon from '@/assets/icons/spectrum-cushion.svg';
import spectrumCushionFancyIcon from '@/assets/icons/spectrum-cushion-fancy.svg';
import spectrumEmeraldIcon from '@/assets/icons/spectrum-emerald.svg';
import spectrumHeartIcon from '@/assets/icons/spectrum-heart.svg';
import spectrumLightingIcon from '@/assets/icons/spectrum-lighting.svg';
import spectrumLightingD65Icon from '@/assets/icons/spectrum-lighting-d65.svg';
import spectrumLightingFluorescentIcon from '@/assets/icons/spectrum-lighting-fluorescent.svg';
import spectrumLightingLedIcon from '@/assets/icons/spectrum-lighting-led.svg';
import spectrumMarquiseIcon from '@/assets/icons/spectrum-marquise.svg';
import spectrumOtherIcon from '@/assets/icons/spectrum-other.svg';
import spectrumOvalIcon from '@/assets/icons/spectrum-oval.svg';
import spectrumOvalFancyIcon from '@/assets/icons/spectrum-oval-fancy.svg';
import spectrumPearIcon from '@/assets/icons/spectrum-pear.svg';
import spectrumPrincessIcon from '@/assets/icons/spectrum-princess.svg';
import spectrumRadiantIcon from '@/assets/icons/spectrum-radiant.svg';
import spectrumRoughIcon from '@/assets/icons/spectrum-rough.svg';
import spectrumRoundIcon from '@/assets/icons/spectrum-round.svg';
import speedIcon from '@/assets/icons/speed.svg';
import starIcon from '@/assets/icons/star.svg';
import starOutlineIcon from '@/assets/icons/star-outline.svg';
import surfaceInclusionsIcon from '@/assets/icons/surface-inclusions.svg';
import swapIcon from '@/assets/icons/swap.svg';
import themeDarkIcon from '@/assets/icons/theme-dark.svg';
import themeLightIcon from '@/assets/icons/theme-light.svg';
import touchInclusionsIcon from '@/assets/icons/touch-inclusions.svg';
import uniformityIcon from '@/assets/icons/uniformity.svg';
import userBillingEurIcon from '@/assets/icons/user-billing-eur.svg';
import userBillingUsdIcon from '@/assets/icons/user-billing-usd.svg';
import userImportIcon from '@/assets/icons/user-import.svg';
import userLogoutIcon from '@/assets/icons/user-logout.svg';
import userMyCollectionsIcon from '@/assets/icons/user-my-collections.svg';
import userProfileIcon from '@/assets/icons/user-profile.svg';
import verifyIcon from '@/assets/icons/verify.svg';
import viewBigIcon from '@/assets/icons/view-big.svg';
import viewChartIcon from '@/assets/icons/view-chart.svg';
import viewComboIcon from '@/assets/icons/view-combo.svg';
import viewComboLgIcon from '@/assets/icons/view-combo-lg.svg';
import viewCrosstabIcon from '@/assets/icons/view-crosstab.svg';
import viewExSmallIcon from '@/assets/icons/view-ex-small.svg';
import viewLittleIcon from '@/assets/icons/view-little.svg';
import viewSmallIcon from '@/assets/icons/view-small.svg';
import viewTabIcon from '@/assets/icons/view-tab.svg';
import warningIcon from '@/assets/icons/warning.svg';
import wechatIcon from '@/assets/icons/wechat.svg';
import whatsappIcon from '@/assets/icons/whatsapp.svg';
import widgetsIcon from '@/assets/icons/widgets.svg';
import windowIcon from '@/assets/icons/window.svg';
import xTwitterIcon from '@/assets/icons/x-twitter.svg';
import zoomInIcon from '@/assets/icons/zoom-in.svg';
import zoomOutIcon from '@/assets/icons/zoom-out.svg';
import zoomToFitIcon from '@/assets/icons/zoom-to-fit.svg';

export const ICONS: Record<string, FC<SVGProps<SVGSVGElement>>> = {
  '3d-cardboard': icon3dCardboardIcon,
  '3d-model': icon3dModelIcon,
  '3d-tv': icon3dTvIcon,
  '4v-360': icon4v360Icon,
  '4v-crown': icon4vCrownIcon,
  '4v-left': icon4vLeftIcon,
  '4v-pavillion': icon4vPavillionIcon,
  '4v-right': icon4vRightIcon,
  '4v-side-view-table-down': icon4vSideViewTableDownIcon,
  '4v-side-view-table-up': icon4vSideViewTableUpIcon,
  'add-model': addModelIcon,
  'add-model-squared': addModelSquaredIcon,
  'add-person': addPersonIcon,
  aperture: apertureIcon,
  'arrow-bold-down': arrowBoldDownIcon,
  'arrow-bold-left': arrowBoldLeftIcon,
  'arrow-bold-right': arrowBoldRightIcon,
  'arrow-lt-down': arrowLtDownIcon,
  'arrow-lt-left': arrowLtLeftIcon,
  'arrow-lt-right': arrowLtRightIcon,
  'arrow-lt-up': arrowLtUpIcon,
  'arrow-mid-down': arrowMidDownIcon,
  'arrow-mid-left': arrowMidLeftIcon,
  'arrow-mid-right': arrowMidRightIcon,
  'arrow-mid-up': arrowMidUpIcon,
  'arrow-selector-down': arrowSelectorDownIcon,
  'arrow-selector-up': arrowSelectorUpIcon,
  'arrows-asc': arrowsAscIcon,
  'arrows-desc': arrowsDescIcon,
  'available-data': availableDataIcon,
  'back-hand': backHandIcon,
  'back-hand-practice': backHandPracticeIcon,
  block: blockIcon,
  book: bookIcon,
  bookmark: bookmarkIcon,
  'bookmark-fill': bookmarkFillIcon,
  'brain-stereo-vision': brainStereoVisionIcon,
  calendar: calendarIcon,
  cancelled: cancelledIcon,
  'carbon-project': carbonProjectIcon,
  chat: chatIcon,
  check: checkIcon,
  clock: clockIcon,
  'clock-back': clockBackIcon,
  close: closeIcon,
  'cloud-upload': cloudUploadIcon,
  code: codeIcon,
  'collapse-all': collapseAllIcon,
  collection: collectionIcon,
  communities: communitiesIcon,
  compare: compareIcon,
  'compare-arrows': compareArrowsIcon,
  'compare-fill': compareFillIcon,
  completed: completedIcon,
  controls: controlsIcon,
  cube: cubeIcon,
  'cube-rotation': cubeRotationIcon,
  'cut-brand': cutBrandIcon,
  cutwise: cutwiseIcon,
  'cutwise-drive': cutwiseDriveIcon,
  'cyclops-vision': cyclopsVisionIcon,
  deadzone: deadzoneIcon,
  delete: deleteIcon,
  'description-off': descriptionOffIcon,
  'description-on': descriptionOnIcon,
  diamond: diamondIcon,
  'diamond-filled': diamondFilledIcon,
  'diamond-shine': diamondShineIcon,
  'distance-to-diamond': distanceToDiamondIcon,
  'distance-to-inclusions': distanceToInclusionsIcon,
  'distance-to-rough': distanceToRoughIcon,
  documentation: documentationIcon,
  download: downloadIcon,
  drag: dragIcon,
  'drag-handle': dragHandleIcon,
  edit: editIcon,
  email: emailIcon,
  expand: expandIcon,
  'expand-all': expandAllIcon,
  facebook: facebookIcon,
  failed: failedIcon,
  'file-conversion': fileConversionIcon,
  'file-tree': fileTreeIcon,
  filter: filterIcon,
  folder: folderIcon,
  'folder-add': folderAddIcon,
  'folder-move': folderMoveIcon,
  'full-protect': fullProtectIcon,
  'fullscreen-off': fullscreenOffIcon,
  'fullscreen-on': fullscreenOnIcon,
  gem: gemIcon,
  grayscale: grayscaleIcon,
  gyro: gyroIcon,
  hamburger: hamburgerIcon,
  help: helpIcon,
  history: historyIcon,
  'history-event': historyEventIcon,
  inclusion: inclusionIcon,
  'inclusions-inside': inclusionsInsideIcon,
  'inclusions-inside-old': inclusionsInsideOldIcon,
  info: infoIcon,
  information: informationIcon,
  inspect: inspectIcon,
  instagram: instagramIcon,
  jewelry: jewelryIcon,
  'key-arrow-down': keyArrowDownIcon,
  'key-arrow-left': keyArrowLeftIcon,
  'key-arrow-right': keyArrowRightIcon,
  'key-ctrl': keyCtrlIcon,
  'key-enter': keyEnterIcon,
  'key-option': keyOptionIcon,
  'key-shift': keyShiftIcon,
  'left-right-eye': leftRightEyeIcon,
  'leia-tablet': leiaTabletIcon,
  'lens-f-11': lensF11Icon,
  'lens-f-16': lensF16Icon,
  'lens-f-28': lensF28Icon,
  'lens-f-infinity': lensFInfinityIcon,
  lighting: lightingIcon,
  'lighting-d65': lightingD65Icon,
  'lighting-fluorescent': lightingFluorescentIcon,
  'lighting-led': lightingLedIcon,
  like: likeIcon,
  'like-fill': likeFillIcon,
  link: linkIcon,
  'link-info': linkInfoIcon,
  linkedin: linkedinIcon,
  'long-arrow-right': longArrowRightIcon,
  'marker-cutwise-grade': markerCutwiseGradeIcon,
  'marker-laboratory-grade': markerLaboratoryGradeIcon,
  'marker-manual-grade': markerManualGradeIcon,
  'marker-supplier-grade': markerSupplierGradeIcon,
  marquise: marquiseIcon,
  media: mediaIcon,
  'metrics-brightness': metricsBrightnessIcon,
  'metrics-brightness-faceup': metricsBrightnessFaceupIcon,
  'metrics-brilliance': metricsBrillianceIcon,
  'metrics-carat': metricsCaratIcon,
  'metrics-clarity': metricsClarityIcon,
  'metrics-color': metricsColorIcon,
  'metrics-color-material': metricsColorMaterialIcon,
  'metrics-color-pavilion': metricsColorPavilionIcon,
  'metrics-color-table': metricsColorTableIcon,
  'metrics-culet': metricsCuletIcon,
  'metrics-cut': metricsCutIcon,
  'metrics-cut-perf': metricsCutPerfIcon,
  'metrics-cutwise-color': metricsCutwiseColorIcon,
  'metrics-durability': metricsDurabilityIcon,
  'metrics-fire': metricsFireIcon,
  'metrics-fluor': metricsFluorIcon,
  'metrics-fluor-table': metricsFluorTableIcon,
  'metrics-girdle': metricsGirdleIcon,
  'metrics-ident': metricsIdentIcon,
  'metrics-identification': metricsIdentificationIcon,
  'metrics-laboratory-color': metricsLaboratoryColorIcon,
  'metrics-manual-color': metricsManualColorIcon,
  'metrics-measurments': metricsMeasurmentsIcon,
  'metrics-milkiness': metricsMilkinessIcon,
  'metrics-normalized–cut-perf': metricsNormalizedCutPerfIcon,
  'metrics-optical-performance': metricsOpticalPerformanceIcon,
  'metrics-optical-performance-area': metricsOpticalPerformanceAreaIcon,
  'metrics-optical-symmetry': metricsOpticalSymmetryIcon,
  'metrics-polish': metricsPolishIcon,
  'metrics-scintillation': metricsScintillationIcon,
  'metrics-shape': metricsShapeIcon,
  'metrics-spread': metricsSpreadIcon,
  'metrics-supplier-color': metricsSupplierColorIcon,
  'metrics-symmetry': metricsSymmetryIcon,
  'metrics-transparency': metricsTransparencyIcon,
  'metrics-treatment': metricsTreatmentIcon,
  'models-linked': modelsLinkedIcon,
  more: moreIcon,
  'more-circles': moreCirclesIcon,
  multistage: multistageIcon,
  'multistage-shared': multistageSharedIcon,
  munsell: munsellIcon,
  'my-lists': myListsIcon,
  next: nextIcon,
  'octonus-color': octonusColorIcon,
  'color-strength': colorStrengthIcon,
  uniformity: uniformityIcon,
  'color-name': colorNameIcon,
  'color-probability': colorProbabilityIcon,
  'fcrf-subgrades': fcrfSubgradesIcon,
  oval: ovalIcon,
  palette: paletteIcon,
  pause: pauseIcon,
  pencil: pencilIcon,
  pending: pendingIcon,
  'pin-filled': pinFilledIcon,
  'pin-off': pinOffIcon,
  'pin-on': pinOnIcon,
  'pin-unfilled': pinUnfilledIcon,
  pinterest: pinterestIcon,
  play: playIcon,
  plus: plusIcon,
  'precise-fast': preciseFastIcon,
  prev: prevIcon,
  princess: princessIcon,
  printer: printerIcon,
  'private-access-for-users': privateAccessForUsersIcon,
  'products-new': productsNewIcon,
  'products-removed': productsRemovedIcon,
  project: projectIcon,
  'project-shared': projectSharedIcon,
  protect: protectIcon,
  qr: qrIcon,
  radar: radarIcon,
  'recent-shared-with-me': recentSharedWithMeIcon,
  reprojection: reprojectionIcon,
  'reset-camera': resetCameraIcon,
  rough: roughIcon,
  'rough-2': rough2Icon,
  'rough-caverns': roughCavernsIcon,
  'rough-inclusions': roughInclusionsIcon,
  'rough-shared': roughSharedIcon,
  'rough-surface': roughSurfaceIcon,
  round: roundIcon,
  search: searchIcon,
  'second-display': secondDisplayIcon,
  'selector-down': selectorDownIcon,
  'selector-up': selectorUpIcon,
  'settings-off': settingsOffIcon,
  'settings-on': settingsOnIcon,
  share: shareIcon,
  'share-outline': shareOutlineIcon,
  'show-all': showAllIcon,
  sidebar: sidebarIcon,
  'singlescale-off': singlescaleOffIcon,
  'singlescale-on': singlescaleOnIcon,
  'sort-down': sortDownIcon,
  'sort-up': sortUpIcon,
  'spectrum-cuboid': spectrumCuboidIcon,
  'spectrum-cushion': spectrumCushionIcon,
  'spectrum-cushion-fancy': spectrumCushionFancyIcon,
  'spectrum-emerald': spectrumEmeraldIcon,
  'spectrum-heart': spectrumHeartIcon,
  'spectrum-lighting': spectrumLightingIcon,
  'spectrum-lighting-d65': spectrumLightingD65Icon,
  'spectrum-lighting-fluorescent': spectrumLightingFluorescentIcon,
  'spectrum-lighting-led': spectrumLightingLedIcon,
  'spectrum-marquise': spectrumMarquiseIcon,
  'spectrum-other': spectrumOtherIcon,
  'spectrum-oval': spectrumOvalIcon,
  'spectrum-oval-fancy': spectrumOvalFancyIcon,
  'spectrum-pear': spectrumPearIcon,
  'spectrum-princess': spectrumPrincessIcon,
  'spectrum-radiant': spectrumRadiantIcon,
  'spectrum-rough': spectrumRoughIcon,
  'spectrum-round': spectrumRoundIcon,
  speed: speedIcon,
  star: starIcon,
  'star-outline': starOutlineIcon,
  'surface-inclusions': surfaceInclusionsIcon,
  swap: swapIcon,
  'theme-dark': themeDarkIcon,
  'theme-light': themeLightIcon,
  'touch-inclusions': touchInclusionsIcon,
  'user-billing-eur': userBillingEurIcon,
  'user-billing-usd': userBillingUsdIcon,
  'user-import': userImportIcon,
  'user-logout': userLogoutIcon,
  'user-my-collections': userMyCollectionsIcon,
  'user-profile': userProfileIcon,
  'view-big': viewBigIcon,
  'view-chart': viewChartIcon,
  'view-combo': viewComboIcon,
  'view-combo-lg': viewComboLgIcon,
  'view-crosstab': viewCrosstabIcon,
  'view-ex-small': viewExSmallIcon,
  'view-little': viewLittleIcon,
  'view-small': viewSmallIcon,
  'view-tab': viewTabIcon,
  verify: verifyIcon,
  warning: warningIcon,
  wechat: wechatIcon,
  whatsapp: whatsappIcon,
  widgets: widgetsIcon,
  window: windowIcon,
  'x-twitter': xTwitterIcon,
  'zoom-in': zoomInIcon,
  'zoom-out': zoomOutIcon,
  'zoom-to-fit': zoomToFitIcon,
};
